import React, { useState } from "react";
import axios from "axios";
import { Link } from "gatsby";
import * as qs from "query-string";
import styled from "styled-components";
import closeIcon from "../../assets/close-circle.svg";
import {
  ErrorDiv,
  InputHeader,
  InputWrapper,
  StyledInput,
  StyledCheckbox,
} from "./../newsletterStyles";

const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  padding: 0;
  border: none;
  top: 0;
  left: 0;
  z-index: 900;
  background-color: rgba(6, 41, 85, 0.7);
`;

const NoScrollDiv = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
`;

const ModalWrapper = styled.div`
  padding: 48px;
  border-radius: 16px;
  box-shadow: 0 6px 20px 0 rgba(36, 45, 65, 0.1);
  background-color: #fff;
  width: 800px;
  position: fixed;
  z-index: 999;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: left;
  cursor: default;
  @media (max-width: 768px) {
    width: 100vw;
    padding: 20px 16px;
    top: 54%;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2.5rem;
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 1.33;
  color: #242d41;
`;

const StyledCloseButton = styled.button`
  background-color: transparent;
  border: none;
  padding: 0;
  width: 28px;
  height: 29px;
  align-items: flex-start;
  flex-shrink: 0;
  cursor: pointer;
  &:focus {
    outline: none;
  }
  img {
    width: 28px;
    height: 29px;
  }
`;

const LinksDiv = styled.div`
  display: flex;
  flex-direction: column;
  & li {
    color: #242d41;
    margin-bottom: 8px;
  }
  & a {
    color: #3382e6;
  }
`;

const NewsLetterWrapper = styled.div`
  display: flex;
  color: rgba(36, 45, 65, 0.9);
  font-size: 14px;
  margin-bottom: 28px;
`;

const CheckboxWrapper = styled.div`
  margin-top: 4px;
`;

const TermsWrapper = styled.div`
  color: rgba(36, 45, 65, 0.9);
  font-size: 18px;
  line-height: 1.33;
  margin-bottom: 40px;
`;

const ButtonWrapper = styled.div`
  margin-top: 20px;
  display: flex;
`;

const ScheduleDemoButton = styled.button`
  width: 180px;
  height: 46px;
  padding: 0;
  font-size: 16px;
  border-radius: 23px;
  font-weight: bold;
  color: #1e5bb5;
  background-color: #fff;
  border: solid 2px #1e5bb5;
`;

const DemoModal = ({ handleClose }) => {
  const [emailError, setEmailError] = useState(false);
  const [invalidEmailError, setInvalidEmailError] = useState(false);
  const [emailInput, setEmailInput] = useState(null);
  const [newsletter, setNewsletter] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [showConfirmationPage, setShowConfirmationPage] = useState(false);

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const handleInputChange = (value, key) => {
    if (key === "email") {
      setEmailInput(value);
      setInvalidEmailError(false);
      setEmailError(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!emailInput) {
      if (!emailInput) setEmailError(true);
      return;
    }
    if (!validateEmail(emailInput)) {
      setInvalidEmailError(true);
      return;
    }
    const formData = {
      email: emailInput,
      newsletter: newsletter,
      identifier: "mel-manager-trial",
      "form-name": "mel-manager-trial",
    };
    const axiosOptions = {
      url: window.location.href,
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: qs.stringify(formData),
    };
    axios(axiosOptions)
      .then(() => {
        setEmailInput(null);
        setShowConfirmationPage(true);
      })
      .catch((err) => {
        console.error("Submission failed");
        const genericMessage = "Something went wrong, please try again";
        setSubmitError(err.msg || genericMessage);
      });
  };

  const renderConfirmationPage = () => {
    return (
      <div>
        <h5>Thank you for requesting a trial with us</h5>
        <p>
          One of our sales representatives will be in touch with you shortly to
          set up your trial account. In the meantime please feel free to explore
          our full line of aviation products:
        </p>
        <LinksDiv>
          <ul>
            <li>
              <a href="https://www.trustflight.com/centrik/">Centrik SMS/QMS</a>
            </li>
            <li>
              <a href="https://www.trustflight.com/techlog/">
                Electronic Tech Log
              </a>
            </li>
            <li>
              <a href="https://www.trustflight.com/reliability-analytics/">
                Reliability Analytics
              </a>
            </li>
          </ul>
        </LinksDiv>
      </div>
    );
  };

  return (
    <Overlay onClick={handleClose} data-backdrop="false">
      <NoScrollDiv>
        <ModalWrapper onClick={(e) => e.stopPropagation()}>
          {showConfirmationPage ? (
            renderConfirmationPage()
          ) : (
            <>
              <TitleWrapper>
                <Title>Start your journey with MEL Manager</Title>
                <StyledCloseButton onClick={handleClose}>
                  <img src={closeIcon} alt="close icon" />
                </StyledCloseButton>
              </TitleWrapper>
              <form
                name="mel-manager-trial"
                method="post"
                data-netlify="true"
                data-netlify-honeypot="bot-field"
                onSubmit={(event) => this.handleSubmit(event)}
              >
                <input type="hidden" name="email" />
                <input type="hidden" name="name" />
                <input type="hidden" name="number" />
                <input type="hidden" name="identifier" />
                <input
                  type="hidden"
                  name="form-name"
                  value="mel-manager-trial"
                />
                <InputWrapper>
                  <InputHeader>Work email</InputHeader>
                  <StyledInput
                    onChange={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleInputChange(e.target.value, "email");
                    }}
                    error={emailError}
                    onClick={(e) => e.stopPropagation()}
                    name="email"
                  />
                  {emailError ? (
                    <ErrorDiv>This field is required.</ErrorDiv>
                  ) : null}
                  {invalidEmailError ? (
                    <ErrorDiv>This must be a valid email address</ErrorDiv>
                  ) : null}
                </InputWrapper>
                <NewsLetterWrapper>
                  <CheckboxWrapper>
                    <StyledCheckbox
                      type="checkbox"
                      onChange={() => setNewsletter(true)}
                      checked={newsletter}
                    />
                  </CheckboxWrapper>
                  Yes, I would like to receive promotional emails, including
                  product news, events and more.
                </NewsLetterWrapper>
                <TermsWrapper>
                  By submitting this form, I agree to TrustFlight’s{" "}
                  <Link to="/terms">Terms of Service</Link> and acknowledge its{" "}
                  <Link to="/legal">Privacy Policy</Link>.
                </TermsWrapper>
                <ButtonWrapper>
                  <ScheduleDemoButton
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSubmit(e);
                    }}
                  >
                    CONTACT US
                  </ScheduleDemoButton>
                </ButtonWrapper>
                {submitError ? <ErrorDiv>{submitError}</ErrorDiv> : null}
              </form>
            </>
          )}
        </ModalWrapper>
      </NoScrollDiv>
    </Overlay>
  );
};

export default DemoModal;
